var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFloorPlan(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    "data-name": "floor plan"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 51",
    style: {
      fill: "none",
      opacity: 0.509
    },
    d: "M0 0h20v20H0z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 49",
    d: "M433.439 1305.591h-17.981v-17.956h7.142l3.07 2.645-1.305 1.515-2.507-2.16h-4.4v13.956h13.982v-13.956h-4.888v-2h6.888z",
    style: {
      fill: "#939393"
    },
    transform: "translate(-414.458 -1286.654)"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 50",
    d: "M433.2 1298.45h-2.975v-2h2.975z",
    transform: "translate(-415.429 -1286.151)",
    style: {
      fill: "#939393"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 51",
    d: "M426.928 1298.45h-5.866v-2h5.866z",
    transform: "translate(-414.787 -1286.151)",
    style: {
      fill: "#939393"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 52",
    d: "M425.2 1305h-2v-7.656h2z",
    transform: "translate(-414.998 -1287.058)",
    style: {
      fill: "#939393"
    }
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFloorPlan);
export default __webpack_public_path__ + "static/media/floor_plan.0afb3010cd08e267c04703b4e693ec7e.svg";
export { ForwardRef as ReactComponent };